import {ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output, OnInit, OnDestroy} from '@angular/core';
import {PanelService} from '../../../../commons/angular/services/panel.service';
import {InsightEntityType, RecommendationHolderType} from "../../../models/recommendation.model";
import {
  RecommendationGroupsPanelLayoutComponent
} from "../recommendation-groups-panel-layout/recommendation-groups-panel-layout.component";
import {RecommendationPanelLayoutComponent} from "../recommendation-panel-layout/recommendation-panel-layout.component";
import {AiAgentModel} from "../../../../ai-agents/models/ai-agent.model";
import {RecommendationProcessModel} from "../../../models/recommendation.model";

const PANEL_CONFIG = {
  width: 400,
  height: 500,
  hasBackdrop: false,
  position: {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
    offsetX: 0,
    offsetY: 50
  }
};

require('./recommendation-widget.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-recommendation-widget',
  templateUrl: './recommendation-widget.html',
})
export class RecommendationWidgetComponent implements OnDestroy {
  @Input() holderId: string;
  @Input() draftId: string;
  @Input() holderType: RecommendationHolderType;
  @Input() entityType: InsightEntityType;
  @Input() compactLayout: boolean = false;
  @Input() allowGenerateRecommendations: boolean = false;
  @Input() onGenerateRecommendations: (agent: AiAgentModel) => Promise<RecommendationProcessModel>;
  @Input() panelOpenedAnalyticsId: string;

  @Output() expandClick = new EventEmitter<void>();
  @Output() onAccountSearch = new EventEmitter<string>();
  @Output() openRoutePanelsByIds = new EventEmitter<string[]>();

  private _isOpen: boolean = false;
  private _openedPanelInstance: any = null;

  constructor(
    @Inject(PanelService) private panelService: PanelService,
    @Inject('splitService') private splitService
  ) {
  }

  onExpandClick(event?: MouseEvent): void {
    if (this._isOpen) {
      return;
    }

    const data = {
      holderId: this.holderId,
      draftId: this.draftId,
      holderType: this.holderType,
      entityType: this.entityType,
      direction: this.splitService.getLayoutDirection(),
      allowGenerateRecommendations: this.allowGenerateRecommendations,
      onGenerateRecommendations: this.onGenerateRecommendations,
    };

    this._isOpen = true;

    let panel = null;

    if (this.holderType === RecommendationHolderType.VisitPlan) {
      panel = this.panelService.open(RecommendationGroupsPanelLayoutComponent, event, data, PANEL_CONFIG);
    } else {
      panel = this.panelService.open(RecommendationPanelLayoutComponent, event, data, PANEL_CONFIG);
    }

    if (panel) {
      this._openedPanelInstance = panel.instance;
      panel.afterClose$.subscribe(() => {
        this.expandClick.emit();
        this._isOpen = false;
        this._openedPanelInstance = null;
      });
      panel.instance.onAccountSearch?.subscribe(accountName => {
        this.onAccountSearch.emit(accountName);
      });
      panel.instance.openRoutePanelsByIds?.subscribe(routeIds => {
        this.openRoutePanelsByIds.emit(routeIds);
      });
    }
  }

  ngOnDestroy(): void {
    if (this._openedPanelInstance && typeof this._openedPanelInstance.onClose?.emit === 'function') {
      this._openedPanelInstance.onClose.emit();
    }
  }
}
